// Lib
import React from 'react';

// Utils
import { createFeatureToggledComponent } from '../../feature/createFeatureToggledComponent';

// Components
import ImageModal from './ImageModal';
import ImageModalV2 from './v2/ImageModalV2';

// Constants
import { ExperimentId } from '../../../../common/experiments/experimentsConstants';

/**
 * Feature-flag gate for the image modal.
 * Renders the V2 layout shell when enabled, otherwise falls back to the existing modal.
 */
const ImageModalSwitch = createFeatureToggledComponent<React.ComponentProps<typeof ImageModalV2>>(
    ExperimentId.imageModalV2,
    ImageModalV2,
    ImageModal,
);

export default ImageModalSwitch;
